import React from 'react';
import './App.css';
import Users from './Component/Users/Users';
function App() {
  return (
    <div className="body">
      <Users></Users>
    </div>
  );
}

export default App;
